export interface SearchAutocompleteResultsProps {
  results: ResultRow[];
  imgVariant?: ImageVariant;
  isResultsOpen?: boolean;
  shouldShowArrows?: boolean;
  query?: string;
  correctedQuery?: string;
  selectedItemId?: string | null;
  searchHistory?: ResultItem[];
  shouldShowHistory?: boolean;
  shouldShowSuggestions?: boolean;
  onItemClick?: (id: string, type?: AutocompleteItemType) => void;
  onItemHover?: (value: string, index: number, item?: ResultItem) => void;
  isLoading?: boolean;
  shouldShowImages?: boolean;
  withRowGap?: boolean;
  onQueryClick?: (query: string) => void;
  shouldShowDividers?: boolean;
  shouldShowIcons?: boolean;
  shouldShowClearItemButton?: boolean;
  maxItemsCount?: number;
  maxMobileItemsCount?: number;
  maxHistoryItemsCount?: number;
  maxMobileHistoryItemsCount?: number;
  invertQueryHighlighting?: boolean;
  className?: string;
  onClearItem?: (id: string, type?: AutocompleteItemType) => void;
}

export enum ResultCategory {
  SAVED = 'Saved',
  BOARDS = 'Boards',
  PALETTES = 'Palettes',
}

export enum AutocompleteItemType {
  SUGGESTION = 'Suggestion',
  HISTORY = 'History',
}
export interface ResultItem {
  value: string;
  image?: string | string[];
  title?: string;
  subtitle?: string;
  id: string;
  type?: string;
  sourceType?: string;
}

export interface ResultItemProps {
  item: ResultItem;
  query?: string;
  index?: number;
  imgVariant?: ImageVariant;
  shouldShowArrows?: boolean;
  shoudShowImage?: boolean;
  type?: AutocompleteItemType;
  onClick?: (id: string, type?: AutocompleteItemType) => void;
  customIcon?: React.ReactNode;
  isSelected?: boolean;
  isPreviousItemSelected?: boolean;
  isNextItemSelected?: boolean;
  shouldShowDividers?: boolean;
  shouldShowIcon?: boolean;
  shouldShowClearButton?: boolean;
  invertQueryHighlighting?: boolean;
  isLoggedIn?: boolean;
  onClear?: (id: string, type?: AutocompleteItemType) => void;
  onItemHover?: (value: string, index: number, item?: ResultItem) => void;
}

export interface ResultRow {
  title?: ResultCategory | string;
  items: ResultItem[];
  imgVariant?: ImageVariant;
  shouldShowArrows?: boolean;
  query?: string;
  selectedItemId?: string | null;
  shouldShowImages?: boolean;
  onItemClick?: (id: string, type?: AutocompleteItemType) => void;
  onItemHover?: (value: string, index: number, item?: ResultItem) => void;
  shouldShowDividers?: boolean;
  shouldShowIcons?: boolean;
  maxItemsCount?: number;
  maxMobileItemsCount?: number;
  invertQueryHighlighting?: boolean;
  isMobileDevice?: boolean;
}

export enum ImageVariant {
  SQUARE = 'square',
  CIRCLE = 'circle',
}

export interface DidYouMeanWrapperProps {
  query: string;
  correctedQuery: string;
  onQueryClick: (query: string) => void;
}
